import { ISubmission, ISubmissionData, ISubmissionItem, ISubmissionParams, ITableRes } from 'types'

import { baseApi } from './baseApi'

export const submissionsAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_submissions: builder.query<ITableRes<ISubmissionItem>, ISubmissionParams>({
      query: (params) => ({
        url: '/submissions/',
        params,
      }),
      providesTags: ['submissions'],
    }),
    GET_submissionById: builder.query<ISubmission, string>({
      query: (id) => {
        return {
          url: `/submissions/${id}/`,
        }
      },
      providesTags: ['submission'],
    }),
    POST_submission: builder.mutation<ISubmission, ISubmissionData>({
      query: (body) => ({
        url: `/submissions/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['submission', 'submissions', 'student-assignments'],
    }),
    PUT_submission: builder.mutation<ISubmission, { id: string; body: ISubmissionData }>({
      query: ({ id, body }) => ({
        url: `/submissions/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['submission', 'submissions', 'student-assignments', 'student-assignment'],
    }),
    PUT_submissionPublish: builder.mutation<ISubmission, string>({
      query: (id) => ({
        url: `/submissions/${id}/publish/`,
        method: 'PUT',
      }),
      invalidatesTags: ['submission', 'submissions', 'student-assignments', 'student-assignment'],
    }),
    PUT_submissionRequestResubmission: builder.mutation<ISubmission, string>({
      query: (id) => ({
        url: `/submissions/${id}/request-resubmission/`,
        method: 'PUT',
      }),
      invalidatesTags: ['submission', 'submissions', 'assess'],
    }),
    DELETE_submission: builder.mutation<ISubmission, string>({
      query: (id) => ({
        url: `/submissions/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['submission', 'submissions', 'student-assignments', 'student-assignment'],
    }),
    DELETE_submission_attachments: builder.mutation<ISubmission, { id: string; attachmentId: string }>({
      query: ({ id, attachmentId }) => ({
        url: `/submissions/${id}/materials/${attachmentId}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['submission', 'submissions', 'student-assignments', 'student-assignment'],
    }),
    POST_submission_attachments: builder.mutation<ISubmission, { id: string; formData: any }>({
      query: ({ id, formData }) => ({
        url: `/submissions/${id}/add_materials/`,
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['submission', 'submissions', 'student-assignments', 'student-assignment'],
    }),
  }),
})

export const {
  useGET_submissionsQuery,
  useGET_submissionByIdQuery,
  usePUT_submissionMutation,
  usePOST_submissionMutation,
  usePUT_submissionPublishMutation,
  usePUT_submissionRequestResubmissionMutation,
  useDELETE_submissionMutation,
  useDELETE_submission_attachmentsMutation,
  usePOST_submission_attachmentsMutation,
} = submissionsAPI
